<!--专家服务-->
<template>
<div class="site-content">
  <div class="site-content-banner">
    <img src="./../../assets/kjfw_banner_01.png"/>
  </div>
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <infoPageList-02 title="专家列表" label="INFORMARION" :showTitle="true" :showOrder="false" :showMore="false" :infoPage="infoPage1" :infoBlock="infoBlock1" count="10" v-on:queryPage="zjlb_Req"/>
      </div>
      <div class="content-col col-per-30">
        <infoList title="服务流程" :showTitle="true" :showMore="false" :infoBlock="infoBlock2" count="1" :infoPage="infoPage2"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoPageList02 from '../block/InfoPageList02'
import ZjInfo1 from '../module/ZjInfo1'
import FwlcInfo1 from '../module/FwlcInfo1'
import InfoList from '../block/InfoList'
export default {
  name: 'Jrfw03',
  components: {
    'infoPageList-02': InfoPageList02,
    'infoList':InfoList,
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App---template',
      infoBlock1:ZjInfo1,
      infoBlock2:FwlcInfo1,
      infoPage1:{list:[],total:0},
      infoPage2:{list:[{1:1}],total:1},
    }
  },
  methods:{
    //专家列表
    zjlb_Req(params){
          let that=this;
          let result={page:params};
          console.log('父页面查询参数：'+JSON.stringify(params));
          that.$dataApi.expertLists(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage1=result;
          console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
    //服务流程
    fwlc_Req(params){
          let that=this;
          let result={page:params};
          console.log('父页面查询参数：'+JSON.stringify(params));
          that.$dataApi.orgEnterpriseLists(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage2=result;
          console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Jrfw03.vue